// the disabled overlay color used
export const DISABLED_ELEMENT_OVERLAY_COLOR = "rgba(212,210,210,0.7)";
